import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { replaceStylesheetGlobals } from '../portal/theme/portalTheme';
import { useConversationStore } from '../ConversationStoreProvider';
const ReferenceLink = ({ reference, referenceFormatting, openWebPagesInNewTab = false, }) => {
    const store = useConversationStore();
    const stylesheet = store?.stylesheet || {};
    return (_jsxs(Box, { component: "a", href: reference.url, target: openWebPagesInNewTab ? '_blank' : '_self', rel: openWebPagesInNewTab ? 'noopener noreferrer' : undefined, sx: {
            display: 'block',
            padding: '12px',
            marginBottom: '8px',
            textDecoration: 'none',
            color: replaceStylesheetGlobals(stylesheet, 'color_font') || '#1f2937',
            backgroundColor: replaceStylesheetGlobals(stylesheet, 'color_background') || '#ffffff',
            border: referenceFormatting?.outline
                ? `${referenceFormatting.outlineWeight || 1}px ${referenceFormatting.outlineType || 'solid'} ${referenceFormatting.outlineColor || '#e5e7eb'}`
                : '1px solid #e5e7eb',
            borderRadius: '4px',
            '&:hover': {
                backgroundColor: replaceStylesheetGlobals(stylesheet, 'color_primary') || '#3b82f6',
                color: '#ffffff',
                textDecoration: 'none',
            },
        }, children: [_jsx(Typography, { variant: "body1", sx: {
                    fontWeight: 500,
                    marginBottom: reference.description ? '4px' : 0,
                }, children: reference.title }), reference.description && (_jsx(Typography, { variant: "body2", sx: {
                    color: 'inherit',
                    opacity: 0.8,
                }, children: reference.description }))] }));
};
export default ReferenceLink;
//# sourceMappingURL=ReferenceLink.js.map